__turbopack_context__.v({
  "asset": "wjm4Oa_asset",
  "assetImage": "wjm4Oa_assetImage",
  "card": "wjm4Oa_card",
  "cardSubtitle": "wjm4Oa_cardSubtitle",
  "cardTitle": "wjm4Oa_cardTitle",
  "grid": "wjm4Oa_grid",
  "heading": "wjm4Oa_heading",
  "section": "wjm4Oa_section",
  "text": "wjm4Oa_text",
});
